import { ApiUrl } from "../utils/modules";

class MessageServices {
    constructor(api) {
        this.api = api;
      }
    
    create(formData) {
        const headers = formData instanceof FormData ? { "Content-Type": "multipart/form-data" } : {};
        return this.api.post(ApiUrl + "message?source=messages", formData, {headers});
    }

    getByDiscussion(discussionId) {
        return this.api.get(ApiUrl + `message/discussion/${discussionId}`);
    }

    markMessagesAsRead(discussionId, data) {
        return this.api.patch(ApiUrl + `message/${discussionId}`, data);
    } 
    sendMessageMail(data) {
        return this.api.post(ApiUrl + "message/mail/sendMessage", data);
    }   

}

export default MessageServices;
